module.exports = __webpack_public_path__ + "img/icon-btn-apk1.405488f2.png";